import { PreviewCourseCategoryPage } from '@hendrx/core/courses';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/courses/preview/$courseDraftId/$categoryId/')({
  component: PreviewCourseCategoryPageComponent
});

function PreviewCourseCategoryPageComponent() {
  const { categoryId, courseDraftId } = Route.useParams();

  return <PreviewCourseCategoryPage categoryId={categoryId} courseDraftId={courseDraftId} />;
}
